import {
  RiArrowGoBackLine as ArrowGoBackLine,
  RiArrowGoForwardLine as ArrowGoForwardLine,
  RiArrowLeftLine as ArrowLeftLine,
  RiArrowLeftSLine as ArrowLeftSLine,
  RiArrowRightDownLine as ArrowRightDownLine,
  RiArrowRightLine as ArrowRightLine,
  RiArrowRightSLine as ArrowRightSLine,
  RiArrowRightUpLine as ArrowRightUpLine,
  RiCornerDownRightLine as CornerDownRightLine,
  RiLogoutBoxRLine as LogoutBoxRLine,
  RiSendPlane2Line as SendPlane2Line,
  RiSendPlaneLine as SendPlaneLine,
  type RemixiconComponentType,
} from '@remixicon/react';
import type { ComponentProps } from 'react';

/**
 * YÖN BİLDİREN İKONLAR — sağdan sola dilde aynalanır (29 Eyl 2026).
 *
 * ═══════════════════════════════════════════════════════════════════════════
 * Neden ayrı bir modül
 * ═══════════════════════════════════════════════════════════════════════════
 * Arapçada okuma yönü sağdan sola: "ileri" sola, "geri" sağa bakar. Sağa
 * bakan bir "devam" oku Arapça panelde kullanıcıyı GERİ gidiyormuş gibi
 * yanıltır. Remixicon'un SVG'si yön bilmiyor; aynalama bir işaret ister.
 *
 * Buradaki ikonlar `@remixicon/react`teki adlarıyla AYNI ve tek farkları
 * `data-rtl-mirror` niteliği. `app/rtl.css` o niteliği taşıyan her SVG'yi
 * `[dir='rtl']` altında yatayda çeviriyor. Yani yön bildiren bir ikonu
 * kullanan dosya import satırını buraya çevirir, JSX'e dokunmaz:
 *
 *     import { RiArrowRightLine } from '@/components/ui/rtl-icons';
 *
 * Aynalama `scale` ÖZELLİĞİYLE yapılıyor, `transform` ile değil: açılır
 * listelerde ok `transform: rotate(90deg)` ile dönüyor ve `transform`u ezmek
 * o dönüşü silerdi. `scale` ile `transform` üst üste biniyor.
 *
 * ⚠️ Yön bildirmeyen ikon buraya GİRMEZ: yukarı/aşağı oklar, oynat/ileri sar
 * (medya denetimleri sağdan sola dillerde de soldan sağa kalır), saat ve
 * yenileme okları.
 */
function mirrored(Icon: RemixiconComponentType, name: string): RemixiconComponentType {
  function Mirrored(props: ComponentProps<RemixiconComponentType>) {
    return <Icon data-rtl-mirror="" {...props} />;
  }
  Mirrored.displayName = name;
  return Mirrored;
}

export const RiArrowGoBackLine = mirrored(ArrowGoBackLine, 'RiArrowGoBackLine');
export const RiArrowGoForwardLine = mirrored(ArrowGoForwardLine, 'RiArrowGoForwardLine');
export const RiArrowLeftLine = mirrored(ArrowLeftLine, 'RiArrowLeftLine');
export const RiArrowLeftSLine = mirrored(ArrowLeftSLine, 'RiArrowLeftSLine');
export const RiArrowRightDownLine = mirrored(ArrowRightDownLine, 'RiArrowRightDownLine');
export const RiArrowRightLine = mirrored(ArrowRightLine, 'RiArrowRightLine');
export const RiArrowRightSLine = mirrored(ArrowRightSLine, 'RiArrowRightSLine');
export const RiArrowRightUpLine = mirrored(ArrowRightUpLine, 'RiArrowRightUpLine');
export const RiCornerDownRightLine = mirrored(CornerDownRightLine, 'RiCornerDownRightLine');
export const RiLogoutBoxRLine = mirrored(LogoutBoxRLine, 'RiLogoutBoxRLine');
export const RiSendPlane2Line = mirrored(SendPlane2Line, 'RiSendPlane2Line');
export const RiSendPlaneLine = mirrored(SendPlaneLine, 'RiSendPlaneLine');
